import Skeleton from '@mui/material/Skeleton';

import { Grid } from '@mui/material';
import { sxStyle } from './styles';

const SearchSkeleton = () => {
  return (
    <Grid container sx={sxStyle.root}>
      <Grid
        item
        xs={12}
        sm={12}
        md={6}
        lg={3}
        sx={{ ...sxStyle.contentSkeleton, paddingLeft: '0px' }}
      >
        <Skeleton
          variant="rectangular"
          sx={{
            ...sxStyle.cardSkeleton,
            maxWidth: '95%',
            minHeight: '500px',
          }}
        />
      </Grid>
      <Grid
        item
        xs={12}
        sm={12}
        md={6}
        lg={3}
        sx={{ ...sxStyle.contentSkeleton, paddingLeft: '0px' }}
      >
        <Skeleton
          variant="rect"
          sx={{
            ...sxStyle.cardSkeleton,
            maxWidth: '95%',
            minHeight: '500px',
          }}
        />
      </Grid>
      <Grid
        item
        xs={12}
        sm={12}
        md={6}
        lg={3}
        sx={{ ...sxStyle.contentSkeleton, paddingLeft: '0px' }}
      >
        <Skeleton
          variant="rect"
          sx={{ ...sxStyle.cardSkeleton, maxWidth: '95%', minHeight: '500px' }}
        />
      </Grid>
      <Grid
        item
        xs={12}
        sm={12}
        md={6}
        lg={3}
        sx={{ ...sxStyle.contentSkeleton, paddingLeft: '0px' }}
      >
        <Skeleton
          variant="rect"
          sx={{ ...sxStyle.cardSkeleton, maxWidth: '95%', minHeight: '500px' }}
        />
      </Grid>
    </Grid>
  );
};

export default SearchSkeleton;
